var findLastIndex = require('./findLastIndex');

    /**
     * Returns last item that matches criteria
     */
    function findLast(arr, iterator, thisObj){
        var idx = findLastIndex(arr, iterator, thisObj);
        return idx >= 0? arr[idx] : void(0);
    }

    module.exports = findLast;





//////////////////
// WEBPACK FOOTER
// ./~/mout/array/findLast.js
// module id = 1547
// module chunks = 0 1 2